<template>
  <div class="import-data-history-content conmon-top">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">导入记录</span>
      </el-col>
    </el-row>
    <el-row class="import-data-title">
       <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <el-table-column
          prop="file_name"
          label="文件名称">
        </el-table-column>
        <el-table-column
          prop="name"
          label="导入时间"
          width="">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="导入状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1">
              <!-- <i style="color: green; font-size: 40px; margin-right: 10px; line-height: 10px;">·</i> -->
              已导入
            </div>
            <div v-else >
              <!-- <i style="color: red; font-size: 40px; margin-right: 10px; line-height: 10px;">·</i> -->
              未导入
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="导入结果">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1">
              <b style="color: green;">{{ scope.row.record_count }}</b>条导入成功
            </div>
            <div v-else >
              <b style="color: red;">{{ scope.row.record_count }}</b>条导入失败
            </div>
          </template>
        </el-table-column>
         <!--
        <el-table-column
          prop=""
          label="操作">
           <template slot-scope="scope">
              <div class="op-link" @click="downloadFiles(scope.row.id)">
                下载
              </div>
           </template>
        </el-table-column>
        -->
      </el-table>
       <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getImportDataHistoryList, downloadimportDataHistoryFile, exportDataHistory } from '@/api/customer.js'
import { API_HOST } from '../../api/local.js'
export default {
  name: 'importData',
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0
    }
  },
  methods: {
    load() {
      this.loading = true
      getImportDataHistoryList(this.page).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.count
          console.log(this.totalCount)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      console.log(page)
      this.page = page
      this.load()
    },
    downloadFiles(id) {
      exportDataHistory(id).then(response => {
        this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', '要下载的文件不存在')
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }
  },
  created() {
    this.load()
  },
  components: {
  }
}
</script>

<style scoped>
.import-data-title {
  text-align: left;
}
.import-status {
  display: flex;
  justify-content: center;
}
.search-title {
  margin-top: 20px;
}
</style>
